import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
import store from '@/store/index'; // import { GetEnvNames } from '@/api/sys.user'

export default {
  data: function data() {
    return {
      host: null,
      options: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var users;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.host = util.cookies.get('businessAPI');
              users = process.env.VUE_APP_API_USERS.split(',');
              _this.options = users.map(function (v) {
                var obj = {};
                obj.value = v;
                obj.label = v;
                return obj;
              });

              if (!util.cookies.get('businessAPI')) {
                _this.host = users[0];
                util.cookies.set('businessAPI', users[0]);
              } else {
                _this.host = util.cookies.get('businessAPI');
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleChangle: function handleChangle() {
      util.cookies.set('businessAPI', this.host);
      window.location.reload();
    }
  }
};